const yup = require("yup");

function getAddressSchema({
  requireAddressName = false,
  required = true,
} = {}) {
  const requiredFields = ["address1", "city", "state", "zipcode", "country"];

  // Build base field schemas with common validation logic
  const address1Base = yup
    .string()
    .matches(
      /^\s*\S+(?:\s+\S+){1,9}$/,
      "Enter a full street address (e.g. 123 Main St)",
    )
    .test(
      "no-po-box",
      "PO Boxes are not allowed",
      (value = "") =>
        !/\b(?:P(?:ost)?\.?\s*O(?:ffice)?\.?\s*Box|P\.?\s*O\.?\s*B\.?|\bPOB\b)/i.test(
          value,
        ),
    );

  const zipcodeBase = yup.string().matches(/^\d{5}$/, {
    message: "Zip code must be 5 digits",
    excludeEmptyString: !required,
  });

  // Build the schema shape
  const schemaShape = {
    ...(requireAddressName && {
      addressName: yup.string().required("Location Name is required"),
    }),
    address1: required
      ? address1Base.required("Address is required")
      : address1Base.nullable(),
    address2: yup
      .string()
      .nullable()
      .matches(/^[a-zA-Z\d',. \-#/]+$/, {
        message: "Invalid address format",
        excludeEmptyString: true,
      }),
    city: required
      ? yup.string().required("City is required")
      : yup.string().nullable(),
    state: required
      ? yup.string().required("State is required")
      : yup.string().nullable(),
    zipcode: required
      ? zipcodeBase.required("Zip code is required")
      : zipcodeBase.nullable(),
    country: required
      ? yup.string().required("Country is required")
      : yup.string().nullable(),
    defaultLocation: yup.boolean().optional(),
    geoCode: yup.object().shape({
      x: yup.number().nullable(),
      y: yup.number().nullable(),
    }),
  };

  const schema = yup.object().shape(schemaShape);

  // Add all-or-nothing test only for optional address
  if (!required) {
    return schema.test(
      "all-or-nothing-address",
      "If any address field is filled, all required address fields are required",
      function (value) {
        if (!value) return true;
        const anyFilled = requiredFields.some(
          (field) => value[field] && value[field].toString().trim() !== "",
        );
        if (!anyFilled) return true;
        return requiredFields.every(
          (field) => value[field] && value[field].toString().trim() !== "",
        );
      },
    );
  }

  return schema;
}

export const createLocation = getAddressSchema({ requireAddressName: true });
export const addressValidation = getAddressSchema();
export const optionalAddressValidation = getAddressSchema({ required: false });
